export const validateSaveCandidateGroup = (group) => {
    if (!group.name) {
        alert('Vui lòng nhập tên saved list')
        return false
    }
    if (!group.tab) {
        alert('Vui lòng nhập tên tab')
        return false
    }
    if (!group.level) {
        alert('Vui lòng nhập tên level')
        return false
    }

    return true
}
